// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FIE_topbar-reset-button {
    display: none !important;
}

.FIE_warmth-tool-button {
    display: none !important;
}

.FIE_topbar {
    padding: 8px 16px !important;
}

.FIE_canvas-container {
    padding: 0px !important;
}

.FIE_arrow-tool-options {
    padding: 0px !important;
}

.FIE_ellipse-tool-options {
    padding: 0px !important;
}

.FIE_tool-options-wrapper {
    margin: 0 auto !important;
}

.FIE_tools-bar {
    padding: 0px !important;
}

.FIE_topbar-history-buttons {
    margin-right: 32px !important;
}

.FIE_text-size-option {
    background: transparent !important;

    &:hover {
        text-decoration: none !important;
    }

    &.tEcko:focus-within {
        background: white !important;
        background-color: white !important;
        color: black !important;
    }
}

.SfxInput-root {
    background: white !important;
    color: black !important;

    &:hover {
        background: white !important;
        color: black !important;
    }

    &.tEcko:focus-within {
        background: white !important;
        background-color: white !important;
        color: black !important;
    }

    &.icNcKZ:focus-within {
        background: white !important;
        background-color: white !important;
        color: black !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/presentation/pages/image_editor/ui/body/filerobot.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;;IAElC;QACI,gCAAgC;IACpC;;IAEA;QACI,4BAA4B;QAC5B,kCAAkC;QAClC,uBAAuB;IAC3B;AACJ;;AAEA;IACI,4BAA4B;IAC5B,uBAAuB;;IAEvB;QACI,4BAA4B;QAC5B,uBAAuB;IAC3B;;IAEA;QACI,4BAA4B;QAC5B,kCAAkC;QAClC,uBAAuB;IAC3B;;IAEA;QACI,4BAA4B;QAC5B,kCAAkC;QAClC,uBAAuB;IAC3B;AACJ","sourcesContent":[".FIE_topbar-reset-button {\n    display: none !important;\n}\n\n.FIE_warmth-tool-button {\n    display: none !important;\n}\n\n.FIE_topbar {\n    padding: 8px 16px !important;\n}\n\n.FIE_canvas-container {\n    padding: 0px !important;\n}\n\n.FIE_arrow-tool-options {\n    padding: 0px !important;\n}\n\n.FIE_ellipse-tool-options {\n    padding: 0px !important;\n}\n\n.FIE_tool-options-wrapper {\n    margin: 0 auto !important;\n}\n\n.FIE_tools-bar {\n    padding: 0px !important;\n}\n\n.FIE_topbar-history-buttons {\n    margin-right: 32px !important;\n}\n\n.FIE_text-size-option {\n    background: transparent !important;\n\n    &:hover {\n        text-decoration: none !important;\n    }\n\n    &.tEcko:focus-within {\n        background: white !important;\n        background-color: white !important;\n        color: black !important;\n    }\n}\n\n.SfxInput-root {\n    background: white !important;\n    color: black !important;\n\n    &:hover {\n        background: white !important;\n        color: black !important;\n    }\n\n    &.tEcko:focus-within {\n        background: white !important;\n        background-color: white !important;\n        color: black !important;\n    }\n\n    &.icNcKZ:focus-within {\n        background: white !important;\n        background-color: white !important;\n        color: black !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
